import * as React from "react";

const MessageEnvalopeOpen = props => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7776 5.58359L8.77756 1.58359C8.6954 1.52877 8.59883 1.49951 8.50006 1.49951C8.40129 1.49951 8.30473 1.52877 8.22256 1.58359L2.22256 5.58359C2.15407 5.62928 2.09792 5.69119 2.0591 5.76381C2.02029 5.83642 2.00001 5.9175 2.00006 5.99984V12.4998C2.00006 12.7651 2.10542 13.0194 2.29295 13.2069C2.48049 13.3945 2.73484 13.4998 3.00006 13.4998H14.0001C14.2653 13.4998 14.5196 13.3945 14.7072 13.2069C14.8947 13.0194 15.0001 12.7651 15.0001 12.4998V5.99984C15.0001 5.9175 14.9798 5.83642 14.941 5.76381C14.9022 5.69119 14.8461 5.62928 14.7776 5.58359ZM6.54506 9.49984L3.00006 11.9998V6.97046L6.54506 9.49984ZM7.56819 9.99984H9.43194L12.9713 12.4998H4.02881L7.56819 9.99984ZM10.4551 9.49984L14.0001 6.97046V11.9998L10.4551 9.49984Z"
      fill="#22C55E"
    />
  </svg>
);
export default MessageEnvalopeOpen;
